
import React, { Component, useRef } from 'react'
import './TimesheetMovement.css'
import TimesheetToPodpis from './TimesheetMovement'
import YearList from '../../../YearList'
import dayjs from 'dayjs'


export default class TimesheetMovementList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            report: false,
            reportPodtv: false
        }
    }

    SelectStatusReport = (reportPodtv) => {
        this.setState({
            reportPodtv
        })
    }

    openReport(report, timesheet_number, id_timesheetMovement, kafedra_otdel, month, years, id_months) {
        this.setState({ report, kafedra_otdel, month, years })
        if (report) {
            this.props.postTimesheetPPS(0, 0, 0, this.props.statuss, this.props.id_AVN_User, timesheet_number)
            this.props.postViewReport(true, id_timesheetMovement, timesheet_number)
            this.props.postDimDate(years % 100, id_months)
        }
    }

    render() {
        const {
            ApprovedDocList,
            MonthList,
            ForSignatureList
        } = this.props
        if (this.elHeight && this.elHeight == null) return null
        return (
            <div className="TimesheetMovementList" >
                <div className='Admin_container'>
                    <div className='Admin_menu'>
                        <h3 className={!this.state.reportPodtv && 'active_left'}
                            onClick={() => this.SelectStatusReport(false)}>Документы на подтверждение</h3>

                        <h3 className={this.state.reportPodtv && 'active_right'}
                            onClick={() => this.SelectStatusReport(true)}>Подтвержденные документы</h3>
                    </div>
                    <div className='Admin_instruments' >
                    </div>
                </div>
                {!this.state.reportPodtv ?
                    <div>
                        <div className='Search_container'>
                            <div className="selectors_container" style={{ alignItems: 'center' }}>
                                <div>
                                    <p>Структурное подразделение</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'structure') :
                                            this.props.OpenSelectorOptions(0, null)} >
                                            {this.props.statusS == 0 ? 'Кафедра' : 'Отдел'}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name == 'structure' ?
                                            <span>
                                                <p
                                                    style={{ color: this.props.statusS === 0 && '#7F9CF5' }}
                                                    onClick={() => this.props.SelectStatusS(0)}>
                                                    Кафедра
                                                </p>
                                                <p
                                                    style={{ color: this.props.statusS === 1 && '#7F9CF5' }}
                                                    onClick={() => this.props.SelectStatusS(1)}>
                                                    Отдел
                                                </p>
                                            </span> : null}
                                    </div>
                                </div>
                                {/* <div > */}
                                <p style={{ gridColumnStart: '2', gridColumnEnd: '4', color: '#3182CE' }}>Подтвержденные вами документы автоматически переходят во вкладку "Подтвержденные документы"</p>
                                {/* </div> */}
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '60px' }}>№</th>
                                    <th style={{ width: '40%', textAlign: 'center' }}>Название кафедры/отдела</th>
                                    <th style={{ width: '10%', textAlign: 'center' }}>За месяц</th>
                                    <th style={{ width: '35%', textAlign: 'center' }}>Подготовил(а)</th>
                                    <th style={{ width: '8%' }}>Дата</th>
                                    <th style={{ minWidth: '110px' }}>Статус</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ForSignatureList && ForSignatureList.length && ForSignatureList.filter(a => a.statuss == this.props.statusS).length ? (ForSignatureList.filter(a => a.statuss == this.props.statusS)).map((item, index) => (
                                    <tr key={'SpecialList' + index} onClick={() => this.openReport(true, item.timesheet_number, item.id_timesheetMovement, item.kafedra_otdel, item.months, item.a_year, item.id_months)}
                                        style={{
                                            color: !item.viewed && '#3182CE',
                                            fontWeight: !item.viewed && '600'
                                        }}>
                                        <td>{index + 1}</td>
                                        <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.kafedra_otdel}</td>
                                        <td style={{ padding: '0 10px' }}>{item.months}</td>
                                        <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.s_t_fio}</td>
                                        <td>{item.dates} </td>
                                        <td> {item.approved > 0 && item.viewed ?
                                            <nav className='container'>
                                                <label className="TrueTrue"
                                                    title="Одобрено"
                                                /></nav> : !item.approved && item.viewed ? 'Просмотрено' : 'Новое'}
                                        </td>
                                    </tr>)) : <tr className='EmptyRow'><td colSpan='6'>Новых документов на подтверждения пока нету</td></tr>}
                            </tbody>
                        </table>
                    </div> :


                    /*----------------------------- ApprovedDocs ApprovedDocs ApprovedDocs ApprovedDocs ApprovedDocs ApprovedDocs */
                    <div>
                        <div className='Search_container'>
                            <div className="selectors_container" style={{ gridTemplateColumns: '1fr 0.5fr 0.5fr' }}>
                                <div>
                                    <p>Структурное подразделение</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'structure') :
                                            this.props.OpenSelectorOptions(0, null)} >
                                            {this.props.statusS < 1 ? 'Кафедра' : 'Отдел'}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name == 'structure' ?
                                            <span>
                                                <p
                                                    style={{ color: this.props.statusS === 0 && '#7F9CF5' }}
                                                    onClick={() => this.props.SelectStatusS(0)}>
                                                    Кафедра
                                                </p>
                                                <p
                                                    style={{ color: this.props.statusS === 1 && '#7F9CF5' }}
                                                    onClick={() => this.props.SelectStatusS(1)}>
                                                    Отдел
                                                </p>
                                            </span> : null}
                                    </div>
                                </div>
                                <div>
                                    <p>Год:</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'years') :
                                            this.props.OpenSelectorOptions(0, null)} >
                                            {this.props.id_a_year > 0 ? this.props.year : <b>Выберите год</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name == 'years' ?
                                            <span>
                                                {YearList.map(({ id, name }, offset) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_a_year === id && '#7F9CF5' }}
                                                            key={offset} onClick={() => this.props.ChangeYear(id, name)}>
                                                            {name}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                                <div>
                                    <p>Месяц:</p>
                                    <div className="selector">
                                        <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'month') :
                                            this.props.OpenSelectorOptions(0, null)} >
                                            {this.props.id_months > 0 ? this.props.months : <b>Выберите месяц</b>}
                                        </h2>
                                        {this.props.options === 1 && this.props.option_name === 'month' ?
                                            <span>
                                                {MonthList && MonthList.length && MonthList.map((item, index) => {
                                                    return (
                                                        <p
                                                            style={{ color: this.props.id_months == item.id_months && '#7F9CF5' }}
                                                            key={'months' + index} onClick={() => this.props.ChangeMonth(item.id_months, item.months)}>
                                                            {item.months}
                                                        </p>
                                                    )
                                                })}
                                            </span> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '60px' }}>№</th>
                                    <th style={{ width: '40%', textAlign: 'center' }}>Название кафедры/отдела</th>
                                    <th style={{ width: '10%', textAlign: 'center' }}>За месяц</th>
                                    <th style={{ width: '40%', textAlign: 'center' }}>Подготовил(а)</th>
                                    <th style={{ width: '8%' }}>Дата</th>
                                    <th>Статус</th>
                                    <th>Дата потверждения</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ApprovedDocList && ApprovedDocList.length && ApprovedDocList.filter(a => a.approved && a.id_avn_login == this.props.id_AVN_User).length ?
                                    (ApprovedDocList.filter(a => a.approved && a.id_avn_login == this.props.id_AVN_User)).map((item, index) => (
                                        <tr key={'SpecialList' + index} onClick={() => this.openReport(true, item.timesheet_number, item.id_timesheetMovement, item.kafedra_otdel, item.months, item.a_year, item.id_months)}>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.kafedra_otdel}</td>
                                            <td style={{ padding: '0 10px' }}>{item.months}</td>
                                            <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.s_t_fio}</td>
                                            <td>{item.dates} </td>
                                            <td><nav className='container'> {item.approved > 0 ?
                                                <label className="TrueTrue"
                                                    title="Одобрено"
                                                /> : null}</nav>
                                            </td>
                                            <td>{dayjs(item.approved_dates).format('DD-MM-YYYY')}</td>
                                        </tr>)) : <tr className='EmptyRow'><td colSpan='1000'>Список подтвержденных вами документов пока пуст</td></tr>}
                            </tbody>
                        </table>
                    </div>
                }

                {
                    this.state.report ? <div className='TimesheetPodpisAbsalut'>
                        <i className="fas fa-times" onClick={() => this.openReport(false, null, null, null)}></i>
                        <div>
                            <TimesheetToPodpis {...this.props} {...this.state} />
                        </div>
                    </div> : null
                }
            </div>
        )
    }
}


